import { english } from "flatpickr/dist/l10n/default";
import { Vietnamese } from "flatpickr/dist/l10n/vn";
import "flatpickr/dist/themes/material_blue.css";
import PropTypes from "prop-types";
import React, { useEffect, useRef, useState } from "react";
import Flatpickr from "react-flatpickr";
import { useTranslation } from "react-i18next";
import "./custom-date-filter.scss";
const CustomDateFilter = props => {
  const {
    column,
    onFilter,
    paramFilter,
    listComparator,
    defaultComparatorValue,
    defaultValue,
    isFullInput,
  } = props;
  const { t, i18n } = useTranslation();

  const [flatpickr, setFlatpickr] = useState(null);

  useEffect(() => {
    const dataField = column.dataField;
    let defaultDate = [];
    let defaultComparator = defaultComparatorValue;
    for (const key in paramFilter) {
      if (key.indexOf(dataField) !== -1) {
        defaultDate.push(new Date(paramFilter[key]));
        defaultComparator =
          FILTER_DATE_COMPARATOR[key.split(`filter[${dataField}]`)[1]];
      }
    }
    setSelectedComparator(defaultComparator);
    if (defaultDate && defaultDate.length > 0) {
      if (defaultComparator) {
        if (defaultDate.length > 1) {
          setModeDate(MODE_DATE.RANGE);
          setSelectedComparator("~");
        } else {
          setSelectedComparator(defaultComparator);
        }
      }
      setSelectedDate(defaultDate);
    }
  }, [paramFilter]);

  useEffect(() => {
    if (defaultValue) {
      if (defaultValue.comparator === "~" || defaultValue.value.length === 2) {
        setModeDate(MODE_DATE.RANGE);
      } else {
        setModeDate(MODE_DATE.SINGLE);
      }
      setSelectedComparator(defaultValue.comparator);
      setSelectedDate(defaultValue.value.map(item => new Date(item)));
    }
  }, []);

  useEffect(() => {
    const lang = i18n.language;
    switch (lang) {
      case "vn":
        setOptionDateLocale({
          ...optionDateLocale,
          locale: {
            ...Vietnamese,
            firstDayOfWeek: optionDateLocale.locale.firstDayOfWeek,
          },
        });
        break;
      case "en":
        setOptionDateLocale({
          ...optionDateLocale,
          locale: {
            ...english,
            firstDayOfWeek: optionDateLocale.locale.firstDayOfWeek,
          },
        });
        break;
      default:
        break;
    }
  }, [t]);

  const initOptionDateLocale = {
    altInput: true,
    altFormat: "d/m/Y",
    dateFormat: "d/m/Y",
    allowInput: true,
    locale: {
      ...Vietnamese,
      firstDayOfWeek: 1,
    },
  };
  const [optionDateLocale, setOptionDateLocale] = useState({
    ...initOptionDateLocale,
  });

  const MODE_DATE = {
    SINGLE: "single",
    RANGE: "range",
  };

  const [modeDate, setModeDate] = useState(MODE_DATE.SINGLE);

  const [selectedComparator, setSelectedComparator] = useState(">=");
  const [selectedDate, setSelectedDate] = useState([]);

  const defaultFlatpickr = value => {
    const control = (
      <Flatpickr
        className={`form-control custom-date-filter-table d-block Flatpickr__Input ${
          isFullInput ? "isFullInput" : ""
        }`}
        placeholder={
          modeDate === MODE_DATE.SINGLE
            ? "DD/MM/YYYY"
            : "DD/MM/YYYY - DD/MM/YYYY"
        }
        options={{
          ...optionDateLocale,
          mode: modeDate, // range ,single
        }}
        value={value}
        onChange={date => {
          if (selectedComparator === FILTER_DATE_COMPARATOR[`[range]`]) {
            setSelectedDate(date);
            if (date.length > 1) {
              onFilter({
                comparator: refSelectComparator.current.value,
                date: date,
              });
            }
          } else {
            setSelectedDate(date);
            onFilter({
              comparator: refSelectComparator.current.value,
              date: date,
            });
          }
        }}
      />
    );
    return control;
  };

  useEffect(() => {
    setFlatpickr(defaultFlatpickr(selectedDate));
  }, [selectedDate]);

  useEffect(() => {
    if (modeDate) {
      setFlatpickr(defaultFlatpickr(selectedDate));
    }
  }, [modeDate]);

  const refSelectComparator = useRef(null);
  const FILTER_DATE_COMPARATOR = {
    [`[range]`]: "~",
    [`[eq]`]: "=",
    [`[gt]`]: ">",
    [`[gte]`]: ">=",
    [`[lt]`]: "<",
    [`[lte]`]: "<=",
  };

  return (
    <React.Fragment>
      <div
        className="d-flex gap-2 CustomDateFilter"
        style={{
          width: isFullInput
            ? "auto"
            : modeDate === MODE_DATE.SINGLE
            ? "170px"
            : "304px",
        }}
        onClick={e => {
          e.stopPropagation();
        }}
      >
        <select
          id="date-filter-comparator-maker_date"
          ref={refSelectComparator}
          className="date-filter-comparator form-control "
          value={selectedComparator}
          onChange={e => {
            const value = e.target.value;
            console.log("🚀 ~ CustomDateFilter ~ value:", value);
            if (isFullInput) {
              if (!value) {
                setSelectedComparator(FILTER_DATE_COMPARATOR["[gte]"]);
                setSelectedDate([]);
                onFilter({
                  comparator: value,
                  date: [],
                });
                return;
              }
            }
            setSelectedComparator(value);
            if (value === FILTER_DATE_COMPARATOR[`[range]`]) {
              setFlatpickr(null);
              //   setSelectedDate([]);
              setModeDate(MODE_DATE.RANGE);
              if (selectedDate.length > 0) {
                onFilter({
                  comparator: value,
                  date:
                    selectedDate.length === 1
                      ? [selectedDate[0], selectedDate[0]]
                      : selectedDate,
                });
              }
            } else {
              if (modeDate === MODE_DATE.RANGE) {
                setFlatpickr(null);
                setSelectedDate([]);
                setModeDate(MODE_DATE.SINGLE);
                onFilter({
                  comparator: value,
                  date: [],
                });
              } else if (selectedDate.length > 0) {
                onFilter({
                  comparator: value,
                  date: selectedDate,
                });
              }
            }
          }}
        >
          <option value="">Xóa</option>
          {listComparator && listComparator.length > 0 ? (
            <React.Fragment>
              {listComparator.map(item => {
                return (
                  <option key={item} value={FILTER_DATE_COMPARATOR[item]}>
                    {FILTER_DATE_COMPARATOR[item]}
                  </option>
                );
              })}
            </React.Fragment>
          ) : (
            <React.Fragment>
              <option value={FILTER_DATE_COMPARATOR[`[range]`]}>~</option>
              <option value={FILTER_DATE_COMPARATOR[`[eq]`]}>=</option>
              <option value={FILTER_DATE_COMPARATOR[`[gt]`]}>&gt;</option>
              <option value={FILTER_DATE_COMPARATOR[`[gte]`]}>&gt;=</option>
              <option value={FILTER_DATE_COMPARATOR[`[lt]`]}>&lt;</option>
              <option value={FILTER_DATE_COMPARATOR[`[lte]`]}>&lt;=</option>
            </React.Fragment>
          )}
        </select>
        {flatpickr}
      </div>
    </React.Fragment>
  );
};

CustomDateFilter.propTypes = {
  column: PropTypes.object.isRequired,
  onFilter: PropTypes.func.isRequired,
  paramFilter: PropTypes.any,
  listComparator: PropTypes.any,
  defaultComparatorValue: PropTypes.any,
  defaultValue: PropTypes.any,
  isFullInput: PropTypes.any,
};

CustomDateFilter.defaultProps = {
  defaultComparatorValue: ">=",
};

export default CustomDateFilter;
